import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pillarArticles } from '@/data/articles';
import { isSupportedLanguage } from '@/data/languages';

export default function ArticleSection() {
  const { t } = useTranslation();
  const location = useLocation();
  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  const lang = isSupportedLanguage(firstSegment) ? firstSegment : 'en';

  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-wider text-accent-600">
            {t('home.articleTeaser.eyebrow')}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            {t('pillars.sectionTitle')}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            {t('pillars.sectionSubtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {pillarArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${lang}/${article.slug}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-background-100">
                <img
                  src={article.image}
                  alt={t(`pillars.${article.key}.title`)}
                  title={`${t(`pillars.${article.key}.title`)} Basetao`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="text-xs font-medium text-foreground-500">{article.readTime}</span>
                <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {t(`pillars.${article.key}.title`)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {t(`pillars.${article.key}.desc`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
                  {t('pillars.readMore')}
                  <i className="ri-arrow-right-line text-base leading-none transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}